import './index.scss'
import '../../assets/scripts/number.js'
import Swiper from 'swiper/swiper-bundle.min.js'
// 数字滚动
var istrue = true;
var s = $(window).scrollTop();

if (s >= 0  && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };
$(window).on("scroll",
function() {
   var s = $(window).scrollTop();   
    if (s >= 0 && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)            
        };
        istrue = false;
        
    };
})

 var industrial = new Swiper('.section4 .swiper-container', {
    slidesPerView: 2,
    centeredSlides: true,
    loop: true,
    breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 2,
        spaceBetween: '1.5625%',
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 2,
        spaceBetween: '1.5625%',
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 1,
        spaceBetween: 0,
      }
    },
    navigation: {
        nextEl: ".section4 .swiper-button-next",
        prevEl: ".section4 .swiper-button-prev",
    },
});
var honor = new Swiper(".section6 .mySwiper", {
    slidesPerView: 5,
    spaceBetween: '0.82%',
    loop:true,
    speed:2000,//匀速时间
    autoplay: {
        delay: 0,
        stopOnLastSlide: false,
        disableOnInteraction: false,
    },
    breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 5,
        spaceBetween: '0.82%',
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 3,
        spaceBetween: '1.82%',
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 2,
        spaceBetween: 10,
      }
    } 
});